import React, { useState } from "react";
import logo from "../../images/logo.svg";
import bluewater from "../../images/promotions/bluewater.svg";
import cargowell from "../../images/promotions/cargowell.svg";
import polarlog from "../../images/promotions/polarlog.svg";
import quehenberger from "../../images/promotions/quehenberger.svg";
import transway from "../../images/promotions/transway.svg";
import seifert from "../../images/promotions/seifert.svg";
import forwarder from "../../images/promotions/forwarder.png";
import loadMock from "../../images/promotions/mock-load.png";
import loadMock2 from "../../images/promotions/mock-load2.png";
import { Link } from "react-router-dom";
import styled from "styled-components";
import { Static as StaticOG } from "../static/Styles";
import Container from "../../components/UI/Container";
import LinkButton from "../../components/Buttons/NewButton/LinkButton";
import { API_URL } from "../../constants";

const Static = styled(StaticOG)`
  padding-bottom: 0;
`;

const LinkWrapper = styled.div`
 a {
  text-decoration: none;

    color: #000;
    font-family: Inter;
    font-size: 1rem;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
}
`;

const Button = styled.button`
  color: #fff;
  text-align: center;
  font-family: Inter;
  font-size: 1rem;
  font-style: normal;
  font-weight: 600;
  line-height: normal;

  cursor: pointer;
  background: #4faf82;
  border: none;
  border-radius: 4px;
  padding: 0.75rem 1.25rem;
  transition: 0.25s all ease;
  &:hover {
    transition: 0.25s all ease;
    background: #5ecb98;
    border-color: #07ce94;
  }
`;

const Input = styled.input`
  width: 100%;
  padding: 1rem 0.625rem;
  font-size: 16px;
  border: 1px solid ${(props) => (props.hasError ? "#ff0000" : "#9DAAC0")};
  border-radius: 0.3125rem;
`;

const ListItem = styled.li`
  display: flex;
  flex-direction: column;
  .head {
    display: flex;
    align-items: center;
    gap: 1rem;
    h1 {
      color: #0e114a;
      font-family: Inter;
      font-size: 1.5rem;
      font-style: normal;
      font-weight: 700;
      line-height: normal;

      margin: 0;
      max-width: 100%;

      @media (max-width: 1200px) {
        max-width: 60%;
      }
    }
  }
  p {
    color: #000;
    font-family: Inter;
    font-size: 1rem;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
  }
`;

const EllipseContainer = styled.div`
  contain: layout;
  ::before,
  ::after {
    content: "";
    position: absolute;
    filter: blur(82.9000015258789px);
    z-index: -1;
  }
  ::before {
    top: 0;
    left: 0;
    width: 99.26556rem;
    height: 76.71456rem;
    border-radius: 99.26556rem;
    transform: rotate(32.259deg) translate3d(-40vw, -10vh, 0px);
    background: linear-gradient(
      274deg,
      rgba(255, 255, 255, 0.2) 15.72%,
      rgba(49, 52, 125, 0.2) 84.72%
    );
  }
  ::after {
    top: 30%;
    right: -50%;
    width: 80.50875rem;
    height: 62.21888rem;
    border-radius: 80.50875rem;
    transform: rotate(146.498deg);
    background: linear-gradient(
      274deg,
      rgba(255, 255, 255, 0.2) 15.72%,
      rgba(49, 52, 125, 0.2) 84.72%
    );
  }
`;

const svg = `
  <svg
  width="164" height="164" viewBox="0 0 164 164" fill="none" xmlns="http://www.w3.org/2000/svg"
>
  <path
    d="M51.9615 30L65.302 39.5137L68.6103 23.4658L78.5538 36.489L86.4453 22.1293L92.1085 37.5048L103.882 26.1091L104.762 42.4708L119.371 35.0516L115.389 50.9456L131.536 48.1623L123.046 62.1764L139.296 64.2762L127.052 75.1652L141.962 81.9615L127.052 88.7578L139.296 99.6468L123.046 101.747L131.536 115.761L115.389 112.977L119.371 128.871L104.762 121.452L103.882 137.814L92.1085 126.418L86.4453 141.794L78.5538 127.434L68.6103 140.457L65.302 124.409L51.9615 133.923L53.5304 117.613L37.9784 122.772L44.285 107.649L27.9034 107.995L38.3874 95.4024L22.6317 90.9041L36.3615 81.9615L22.6317 73.019L38.3874 68.5207L27.9034 55.9285L44.285 56.2741L37.9784 41.1512L53.5304 46.31L51.9615 30Z"
    fill="#DD5626"
  />
  <path
    d="M55.1811 92.8035L49.3629 82.7262L51.4935 81.496L56.2975 89.8168L60.6178 87.3225L61.632 89.0791L55.1811 92.8035ZM63.0036 88.2872L58.64 80.7292L60.7362 79.5189L65.0998 87.077L63.0036 88.2872ZM59.1305 79.1469C58.8189 79.3269 58.4918 79.3779 58.1495 79.3C57.8085 79.217 57.5537 79.0295 57.3851 78.7375C57.2184 78.4488 57.1853 78.1377 57.2858 77.8041C57.3877 77.4654 57.5944 77.2061 57.9061 77.0262C58.2177 76.8462 58.544 76.7978 58.885 76.8809C59.2274 76.9587 59.4819 77.142 59.6486 77.4307C59.8172 77.7226 59.8505 78.038 59.7486 78.3767C59.6482 78.7103 59.4421 78.967 59.1305 79.1469ZM66.7789 86.1075L62.4153 78.5495L64.4131 77.3961L65.183 78.7296L65.2715 78.6784C65.1733 78.1447 65.234 77.6438 65.4537 77.1758C65.6734 76.7078 66.0391 76.3261 66.5508 76.0306C67.0691 75.7314 67.5852 75.6062 68.0989 75.6551C68.6108 75.7008 69.0543 75.9084 69.4294 76.2779L69.5082 76.2324C69.4123 75.7104 69.4914 75.2033 69.7452 74.7112C70.0005 74.2139 70.4053 73.8052 70.9597 73.4852C71.665 73.078 72.3671 72.9722 73.0662 73.1678C73.7666 73.3583 74.3536 73.8635 74.8271 74.6836L77.7617 79.7666L75.6705 80.974L72.9744 76.3044C72.732 75.8845 72.4387 75.6339 72.0944 75.5528C71.7501 75.4716 71.4107 75.5276 71.0761 75.7208C70.6955 75.9405 70.4687 76.2333 70.3957 76.5991C70.3207 76.9617 70.3969 77.3398 70.6241 77.7335L73.2889 82.349L71.2567 83.5223L68.5351 78.8084C68.3211 78.4377 68.044 78.204 67.7039 78.1073C67.3671 78.0087 67.0264 78.0589 66.682 78.2577C66.4491 78.3922 66.2732 78.5725 66.1544 78.7985C66.037 79.0194 65.9848 79.2661 65.9977 79.5385C66.0088 79.8077 66.0948 80.0817 66.2558 80.3605L68.8751 84.8973L66.7789 86.1075ZM79.4175 78.8106L75.0539 71.2526L77.15 70.0424L81.5137 77.6004L79.4175 78.8106ZM75.5444 69.6704C75.2327 69.8503 74.9057 69.9013 74.5633 69.8234C74.2223 69.7404 73.9676 69.5529 73.799 69.2609C73.6323 68.9723 73.5992 68.6611 73.6997 68.3276C73.8016 67.9889 74.0083 67.7295 74.3199 67.5496C74.6316 67.3697 74.9579 67.3212 75.2989 67.4043C75.6413 67.4822 75.8958 67.6654 76.0625 67.9541C76.231 68.2461 76.2644 68.5614 76.1625 68.9002C76.0621 69.2337 75.856 69.4905 75.5444 69.6704ZM82.8493 66.7519L83.7584 68.3265L79.2069 70.9543L78.2978 69.3797L82.8493 66.7519ZM78.2856 66.9724L80.3818 65.7621L84.45 72.8084C84.5617 73.002 84.6784 73.1358 84.7999 73.21C84.9196 73.2809 85.0442 73.3073 85.1738 73.2894C85.3067 73.2695 85.4436 73.2189 85.5847 73.1374C85.6831 73.0806 85.7768 73.0156 85.8657 72.9424C85.9528 72.8659 86.0197 72.8076 86.0665 72.7674L87.2968 74.1369C87.2107 74.2303 87.0849 74.3533 86.9192 74.5058C86.7555 74.6615 86.5403 74.8229 86.2737 74.99C85.7799 75.3013 85.2982 75.4898 84.8287 75.5553C84.3624 75.6189 83.9306 75.5489 83.5331 75.3454C83.1357 75.1418 82.7956 74.7915 82.5129 74.2942L78.2856 66.9724ZM92.0269 71.7274C91.2494 72.1763 90.4893 72.4052 89.7466 72.4142C89.0052 72.4179 88.316 72.2166 87.6789 71.8102C87.04 71.4006 86.4905 70.7972 86.0302 70C85.5814 69.2226 85.3383 68.4531 85.3011 67.6917C85.2639 66.9303 85.4245 66.2274 85.7829 65.583C86.1446 64.9368 86.6962 64.3997 87.4376 63.9717C87.9362 63.6838 88.4468 63.4962 88.9693 63.4088C89.4932 63.3163 90.0078 63.3363 90.513 63.4689C91.0214 63.5996 91.5051 63.854 91.9639 64.232C92.4208 64.6068 92.8349 65.1156 93.2061 65.7586L93.5385 66.3343L87.1565 70.019L86.4065 68.7199L90.8154 66.1745C90.6411 65.8727 90.4212 65.6432 90.1555 65.4861C89.8898 65.3289 89.6026 65.252 89.2939 65.2552C88.9867 65.2533 88.6805 65.3404 88.3754 65.5165C88.0572 65.7002 87.8177 65.9369 87.6569 66.2266C87.4975 66.5111 87.4199 66.8161 87.4242 67.1417C87.4266 67.464 87.5123 67.7753 87.6813 68.0758L88.3944 69.3108C88.6103 69.6848 88.8658 69.9681 89.1607 70.1609C89.459 70.3517 89.7787 70.4471 90.1198 70.4469C90.4609 70.4468 90.8069 70.3455 91.1579 70.1428C91.3908 70.0083 91.5851 69.8524 91.7408 69.6751C91.8964 69.4977 92.0053 69.3037 92.0673 69.0929C92.1293 68.8821 92.1415 68.6608 92.1038 68.4289L94.1164 67.4375C94.2869 67.9601 94.32 68.4834 94.2157 69.0072C94.1128 69.5259 93.8777 70.0203 93.5105 70.4903C93.1447 70.9552 92.6502 71.3676 92.0269 71.7274ZM99.6347 67.3023C99.0606 67.6337 98.4554 67.7863 97.8192 67.76C97.1843 67.7285 96.564 67.5027 95.9584 67.0825C95.3542 66.6572 94.8087 66.023 94.322 65.18C93.822 64.3139 93.5457 63.5134 93.4931 62.7783C93.4386 62.04 93.5602 61.3946 93.858 60.8422C94.1571 60.2846 94.5839 59.8457 95.1383 59.5256C95.5615 59.2813 95.9558 59.1499 96.3212 59.1314C96.6881 59.1076 97.02 59.1522 97.3169 59.2651C97.6153 59.3727 97.8691 59.5017 98.0784 59.6521L98.1423 59.6152L95.9548 55.8263L98.0461 54.6189L103.864 64.6963L101.798 65.8895L101.099 64.679L101.01 64.7302C101.033 64.9969 101.014 65.2857 100.953 65.5965C100.893 65.9022 100.759 66.2047 100.552 66.5039C100.347 66.8013 100.041 67.0674 99.6347 67.3023ZM99.3359 65.2507C99.6738 65.0556 99.9061 64.799 100.033 64.4808C100.161 64.1574 100.191 63.7925 100.123 63.3859C100.057 62.9775 99.895 62.5485 99.6355 62.0991C99.376 61.6497 99.0883 61.2953 98.7724 61.036C98.4564 60.7766 98.1283 60.6249 97.7879 60.5808C97.4476 60.5368 97.1084 60.6123 96.7706 60.8074C96.4261 61.0062 96.1898 61.2673 96.0615 61.5907C95.9333 61.914 95.9042 62.2764 95.9741 62.6778C96.044 63.0792 96.2049 63.498 96.4568 63.9343C96.7106 64.3739 96.9957 64.7276 97.3121 64.9954C97.63 65.258 97.9603 65.4172 98.303 65.473C98.6472 65.5237 98.9915 65.4495 99.3359 65.2507ZM76.9307 102.383C76.1663 102.824 75.4116 103.043 74.6664 103.04C73.9226 103.032 73.2313 102.824 72.5924 102.414C71.9515 102.001 71.4077 101.407 70.9607 100.633C70.5099 99.8524 70.2669 99.083 70.2316 98.3248C70.1943 97.5634 70.3592 96.8603 70.7261 96.2154C71.0943 95.5654 71.6606 95.0198 72.425 94.5785C73.1893 94.1372 73.9434 93.9205 74.6871 93.9285C75.4323 93.9313 76.1253 94.1392 76.7661 94.5521C77.405 94.9618 77.9499 95.557 78.4006 96.3377C78.8476 97.1119 79.0897 97.8797 79.1269 98.6411C79.1622 99.3993 78.9958 100.103 78.6275 100.753C78.2606 101.398 77.695 101.941 76.9307 102.383ZM76.003 100.753C76.3507 100.552 76.5842 100.286 76.7035 99.955C76.8209 99.6204 76.8392 99.2468 76.7584 98.8342C76.6809 98.4197 76.5153 97.9926 76.2615 97.5531C76.0077 97.1135 75.7207 96.7565 75.4004 96.4822C75.0835 96.2059 74.7508 96.035 74.4024 95.9693C74.0539 95.9037 73.7058 95.9712 73.3581 96.172C73.0071 96.3747 72.7696 96.6452 72.6457 96.9835C72.525 97.32 72.5035 97.6955 72.5809 98.11C72.6617 98.5226 72.829 98.9487 73.0828 99.3883C73.3366 99.8279 73.6219 100.186 73.9389 100.462C74.2591 100.736 74.5951 100.905 74.9468 100.969C75.2999 101.028 75.652 100.956 76.003 100.753ZM81.6292 89.3957L82.5383 90.9702L77.8736 93.6634L76.9645 92.0888L81.6292 89.3957ZM82.3959 99.0304L77.7169 90.9262C77.4006 90.3783 77.2449 89.8625 77.2498 89.3785C77.258 88.8927 77.397 88.4516 77.6668 88.0552C77.9366 87.6589 78.3093 87.3234 78.7849 87.0488C79.1064 86.8632 79.4142 86.7183 79.7083 86.6141C80.0057 86.508 80.2314 86.4368 80.3854 86.4004L80.9205 88.1909C80.8233 88.212 80.7074 88.2461 80.5728 88.2932C80.4414 88.3384 80.3134 88.397 80.1888 88.469C79.8804 88.647 79.7072 88.8432 79.6692 89.0576C79.6292 89.2688 79.6831 89.5023 79.8309 89.7582L84.4871 97.823L82.3959 99.0304ZM86.9742 86.3097L87.8833 87.8843L83.2186 90.5775L82.3095 89.0029L86.9742 86.3097ZM87.7409 95.9445L83.0619 87.8402C82.7456 87.2924 82.5899 86.7765 82.5948 86.2926C82.603 85.8067 82.742 85.3656 83.0118 84.9693C83.2816 84.573 83.6543 84.2375 84.1299 83.9629C84.4514 83.7773 84.7592 83.6324 85.0533 83.5282C85.3507 83.4221 85.5764 83.3508 85.7304 83.3144L86.2655 85.1049C86.1683 85.126 86.0524 85.1601 85.9178 85.2073C85.7864 85.2525 85.6584 85.3111 85.5338 85.383C85.2254 85.5611 85.0522 85.7573 85.0142 85.9717C84.9742 86.1828 85.0281 86.4163 85.1759 86.6722L89.8321 94.7371L87.7409 95.9445ZM95.8774 91.4436C95.1 91.8925 94.3399 92.1214 93.5971 92.1304C92.8557 92.1341 92.1665 91.9328 91.5295 91.5264C90.8906 91.1168 90.341 90.5134 89.8808 89.7162C89.4319 88.9388 89.1889 88.1693 89.1516 87.4079C89.1144 86.6465 89.275 85.9436 89.6335 85.2992C89.9952 84.653 90.5467 84.1159 91.2881 83.6879C91.7867 83.4 92.2973 83.2124 92.8198 83.125C93.3437 83.0325 93.8583 83.0525 94.3635 83.1851C94.872 83.3158 95.3556 83.5702 95.8144 83.9482C96.2714 84.323 96.6855 84.8318 97.0567 85.4748L97.3891 86.0505L91.007 89.7352L90.257 88.4361L94.6659 85.8907C94.4917 85.5889 94.2717 85.3594 94.006 85.2023C93.7403 85.0451 93.4531 84.9682 93.1445 84.9714C92.8372 84.9695 92.531 85.0566 92.2259 85.2327C91.9077 85.4164 91.6682 85.6531 91.5074 85.9428C91.348 86.2273 91.2705 86.5323 91.2747 86.8579C91.2771 87.1802 91.3628 87.4915 91.5319 87.792L92.245 89.027C92.4609 89.401 92.7163 89.6843 93.0113 89.8771C93.3095 90.0679 93.6292 90.1633 93.9703 90.1631C94.3114 90.163 94.6575 90.0617 95.0085 89.859C95.2414 89.7245 95.4357 89.5686 95.5913 89.3913C95.747 89.2139 95.8558 89.0199 95.9178 88.8091C95.9799 88.5983 95.992 88.377 95.9544 88.1451L97.9669 87.1537C98.1375 87.6763 98.1706 88.1996 98.0662 88.7234C97.9633 89.2421 97.7282 89.7365 97.3611 90.2065C96.9952 90.6714 96.5007 91.0838 95.8774 91.4436ZM100.629 88.5034L96.2655 80.9454L98.2977 79.7721L99.0591 81.0908L99.1378 81.0453C99.0048 80.4967 99.0315 80.0089 99.218 79.5819C99.4026 79.1517 99.7065 78.8144 100.13 78.5701C100.235 78.5095 100.352 78.4507 100.481 78.3937C100.609 78.3368 100.727 78.2933 100.832 78.2632L101.905 80.1232C101.79 80.1505 101.639 80.2028 101.452 80.2803C101.265 80.3577 101.099 80.438 100.954 80.5214C100.646 80.6994 100.409 80.9257 100.244 81.2004C100.081 81.4699 99.9963 81.7634 99.9916 82.081C99.9902 82.3968 100.079 82.7088 100.257 83.0172L102.725 87.2932L100.629 88.5034Z"
    fill="white"
  />
</svg>
`;

const SVGContainer = styled.div`
  ::before {
    content: url('data:image/svg+xml;utf8,${encodeURIComponent(svg)}');
    position: absolute;
    top: 0;
    left: -33%;
    width: 100%;
    height: 100%;
    z-index: 1;
    @media (max-width: 768px) {
      display: none;
    }
    @media (max-width: 1200px) {
      left: -35%;
    }
    @media (max-width: 992px) {
      left: -37%;
    }
}
`;

const Hero = styled.div`
  position: relative;

  h1 {
    color: #dd5626;
    font-family: Inter;
    font-size: 3rem;
    font-style: normal;
    font-weight: 700;
    line-height: normal;

    max-width: 100%;
  }
  p {
    color: #000;
    font-family: Inter;
    font-size: 1.25rem;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
  }
  ul {
      list-style-type: none;
      padding: 0;
      margin-bottom: 2rem;
  }
  ul li::before {
      content: '✓';
      padding-right: 8px;
  }
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 2rem;
  .text {
    width: 60%;
  }
  .image {
    width: 40%;
    transform: translateX(5rem);
    img {
      width: 100%;
    }
  }
  @media (max-width: 768px) {
    flex-direction: column;
    .text {
      width: 100%;
    }
    .image {
      transform: none;
      width: 100%;
      img {
        width: 100%;
      }
    }
  }
`;

const Section1 = styled.section`
  display: flex;
  flex-direction: column;

  margin: 8rem 0;

  h1.head {
    align-self: center;
    max-width: 100%;

    color: #040730;
    font-family: Inter;
    font-size: 3rem;
    font-style: normal;
    font-weight: 700;
    line-height: normal;

    @media (max-width: 768px) {
      color: #040730;
      text-align: center;
      font-family: Inter;
      font-size: 1.5rem;
      font-style: normal;
      font-weight: 700;
      line-height: normal;
    }
  }
  p.head {
    align-self: center;
    max-width: 200%;
    width: max-content;
    color: #000;
    font-family: Inter;
    font-size: 1rem;
    font-style: normal;
    font-weight: 400;
    line-height: normal;

    @media (max-width: 1200px) {
      max-width: 100%;
    }
    @media (max-width: 768px) {
      text-align: center;
    }
  }
  .body {
    display: flex;
    margin-top: 2rem;
    ul {
      list-style: none;
      padding: 0;
      margin: 0;
      width: 60%;

      @media (max-width: 992px) {
        width: auto;
      }
    }
    .images {
      display: flex;
      flex-direction: column;
      width: 40%;

      img {
        position: relative;
        max-width: 100%;
      }
      img:first-child {
        left: 20%;
        scale: 1.6;
        @media (max-width: 1200px) {
          scale: 1.4;
          top: 0;
          left: 0;
        }
      }
      img:last-child {
        top: -20%;
        scale: 1.7;
        @media (max-width: 1200px) {
          scale: 1.8;
          top: 0;
          left: 0;
        }
      }

      @media (max-width: 1200px) {
        justify-content: center;
        gap: 3rem;

        @media (max-width: 992px) {
          display: none;
        }
      }
    }
  }
  .footer {
    display: flex;
    flex-direction: row;
    gap: 1rem;
    margin-top: 8rem;
    h1 {
      color: #000;
      font-family: Inter;
      font-size: 3rem;
      font-style: normal;
      font-weight: 700;
      line-height: normal;

      margin: 0;

      @media (max-width: 768px) {
        text-align: center;
        color: #040730;
        text-align: center;
        font-family: Inter;
        font-size: 1.5rem;
        font-style: normal;
        font-weight: 700;
        line-height: normal;
      }
    }
    p {
      color: #000;
      font-family: Inter;
      font-size: 1rem;
      font-style: normal;
      font-weight: 400;
      line-height: normal;

      margin: 0;
    }

    @media (max-width: 768px) {
      flex-direction: column;
      gap: 2rem;
    }
  }
`;

const Section2 = styled.section`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-bottom: 6rem;
  background-color: #f4f8ff;
  box-shadow: 0 0 0 100vmax #f4f8ff;
  clip-path: inset(0 -100vmax);
  h2 {
    text-align: center;
    width: 60%;

    color: #31347d;
    font-family: Inter;
    font-size: 2rem;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    margin-top: 4rem;
  }
  h1 {
    color: #31347d;
    font-family: Inter;
    font-size: 3rem;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    span {
      color: #dd5626;
      font-family: Inter;
      font-size: 3rem;
      font-style: normal;
      font-weight: 700;
      line-height: normal;
    }
  }
  p#some-partners {
    color: #575756;
    font-family: Inter;
    font-size: 1rem;
    font-style: normal;
    font-weight: 400;
    line-height: normal;

    text-align: center;
    margin: 2rem 0 0 0;
  }
  .partners {
    display: flex;
    gap: 1rem;
    margin-top: 2rem;
    img {
      max-width: 100px;
    }
  }

  @media (max-width: 768px) {
    h1 {
      text-align: center;
    }
    h2 {
      text-align: center;
      width: 100%;
    }
    p#some-partners {
      text-align: center;
    }
    .partners {
      justify-content: center;
      flex-wrap: wrap;
    }
  }
`;

const Join = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 1rem;
  margin: 2rem 0;
  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.2);
  padding: 2rem;
  width: 80%;

  background: #fff;
  .text {
    display: flex;
    flex-direction: column;
    gap: 1rem;

    width: 100%;
    h1 {
      color: #dd5626;
      font-family: Inter;
      font-size: 1.5rem;
      font-style: normal;
      font-weight: 600;
      line-height: normal;

      margin: 0;
      max-width: 100%;
      width: 100%;
    }
    p {
      color: #0e114a;
      font-family: Inter;
      font-size: 1rem;
      font-style: normal;
      font-weight: 400;
      line-height: normal;

      margin: 0;
    }
  }
  .form {
    width: 100%;
    form {
      display: flex;
      justify-content: flex-end;
      gap: 1rem;
      .input {
        width: 100%;
        .h {
          display: flex;
          gap: 1rem;
        }
        .error {
          color: #ff0000;
          font-family: Inter;
          font-size: 0.875rem;
          font-style: normal;
          font-weight: 400;
          line-height: normal;
        }
        .success {
          color: #4faf82;
          font-family: Inter;
          font-size: 0.875rem;
          font-style: normal;
          font-weight: 400;
          line-height: normal;
        }
      }
    }
  }
  @media (max-width: 768px) {
    flex-direction: column;
    .text {
      width: 100%;
    }
    .form {
      width: 100%;
      form {
        .input {
          width: 100%;
          .h {
            flex-direction: column;
          }
        }
      }
    }
  }
`;

const Card = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;
  gap: 1rem;
  margin: 2rem 0;
  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.2);
  padding: 2rem;
  width: 50%;

  h2 {
    color: black;
    font-family: Inter;
    font-size: 1.5rem;
    font-style: normal;
    font-weight: 700;
    line-height: normal;

    margin: 0;
  }

  align-self: center;

  ul {
        list-style-type: none;
        padding: 0;
        margin-bottom: 2rem;
    }
    ul li::before {
        content: '✓';
        padding-right: 8px;
        color: #4FAF82;
        font-size: x-large;
    }

  background: #fff;
  .text {
    display: flex;
    flex-direction: column;
    gap: 1rem;

    width: 100%;
    h1 {
      color: #dd5626;
      font-family: Inter;
      font-size: 1.5rem;
      font-style: normal;
      font-weight: 600;
      line-height: normal;

      margin: 0;
      max-width: 100%;
      width: 100%;
    }
    p {
      color: #0e114a;
      font-family: Inter;
      font-size: 1rem;
      font-style: normal;
      font-weight: 400;
      line-height: normal;

      margin: 0;
    }
  }
  @media (max-width: 768px) {
    flex-direction: column;
    .text {
      width: 100%;
    }
  }
`;

const Logo = styled.div`
  img {
  }
`;

const HaulierPromo = () => {
  const [email, setEmail] = useState("");
  const [error, setError] = useState(false);
  const [success, setSuccess] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    setSuccess(false);
    setError(false);
    if (!email) {
      setError(true);
      return;
    }
    fetch(`${API_URL}/mailing-list/forwarder`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ email }),
    }).then((res) => {
      if (res.status === 200) {
        setSuccess(true);
        setEmail("");
      } else {
        setError(true);
      }
    });
  };

  return (
    <Static>
      <Container gutter={"medium"}>
        <EllipseContainer>
          <Logo>
            <Link to="/">
              <img src={logo} alt="Logo" />
            </Link>
          </Logo>
          <Hero>
            <div className="text">
              <h1>Europe's fastest growing freight exchange!</h1>
              <p>Over 10,000 active hauliers</p>
              <p>
                <b>
                  Sign up now and access the platform for free until the end of
                  the year!
                </b>
              </p>
              <ul>
                <li>Save up to 500€ per month</li>
                <li>Only free solution on the market!</li>
                <li>Unlimited users</li>
              </ul>
              <LinkButton
              landingPage
              to="/sign-up"
              centered="all"
              onClick={() => window.scrollTo(0, 0)}
            >
              Register for Free!
            </LinkButton>            </div>
            <div className="image">
              <img src={forwarder} alt="Forwarder" />
            </div>
          </Hero>
          <Section1>
            <h1 className="head">Why should You choose TransConnector?</h1>
            <p className="head">
              TransConnector offers an all-in-one solution to streamline your
              logistics operations. For a <b>low monthly cost</b>, you can
              unlock all the best features:
            </p>
            <div className="body">
              <ul>
                <ListItem>
                  <div className="head">
                    {listItemIcon}
                    <h1>Load exchange</h1>
                  </div>
                  <p>
                    Easily upload all your loads with just one click via CSV or
                    API. Maximize efficiency and minimize hassle.
                  </p>
                </ListItem>
                <ListItem>
                  <div className="head">
                    {listItemIcon}
                    <h1>Empty trucks</h1>
                  </div>
                  <p>Find available trucks to optimize your operations.</p>
                </ListItem>
                <ListItem>
                  <div className="head">
                    {listItemIcon}
                    <h1>Tender offers & automated bidding</h1>
                  </div>
                  <p>
                    Engage with Europe's top companies through access to
                    exclusive tender offers. Use our automated bidding system to
                    negotiate and secure contracts.
                  </p>
                </ListItem>
              </ul>
              <div className="images">
                <img src={loadMock2} alt="Load2" />
                <img src={loadMock} alt="Load" />
              </div>
            </div>
            <Card>
              <h2>Sign up and access to:</h2>
              <div style={{ display: "flex", gap: "1rem" }}>
                <ul>
                  <li>Roundtrip Offers</li>
                  <li>Roundtrip Requests</li>
                  <li>Ferry bookings</li>
                  <li>GPS tracking</li>
                </ul>
                <ul>
                  <li>Create Roundtrips</li>
                  <li>Create Roundtrip Requests</li>
                  <li>Manage your company</li>
                  <li>Send unlimited messages</li>
                </ul>
              </div>
            </Card>
            <div className="footer">
              <h1>Simplify Your logistics with TransConnector</h1>
              <p>
                Whether you're looking to fill a truck or find a long-term
                logistics partner, TransConnector is your gateway to Europe's
                top opportunities.
                {<br />}
                {<br />}
                By integrating technology with an extensive network of approved
                contractors, we facilitate seamless international
                collaborations.
              </p>
            </div>
          </Section1>
          <Section2>
            <div style={{ position: "relative", textAlign: "-webkit-center" }}>
              <SVGContainer>

              </SVGContainer>
              <h2
                style={{
                  position: "relative",
                  zIndex: 0,
                }}
              >
                Sign up now and get it for free until the end of the year!
              </h2>
            </div>
            <div
              style={{
                marginBlock: "1.5rem",
                display: "flex",
                flexDirection: "row",
                justifyContent: "center",
                alignItems: "center",
                gap: "1rem",
              }}
            >
              <LinkWrapper>
                <Link to={"/roundtrip"}>View Roundtrips</Link>
              </LinkWrapper>
              {" -or- "}
              <LinkButton
                landingPage
                to="/sign-up"
                centered="all"
                onClick={() => window.scrollTo(0, 0)}
              >
                Sign Up Now!
              </LinkButton>
            </div>
            <Join>
              <div className="text">
                <h1>Join our free mailing list today</h1>
                <p>
                  Daily updates on new loads, exclusive offers, and the latest
                  from the logistics world, all delivered directly to your
                  email.
                </p>
              </div>
              <div className="form">
                <form onSubmit={handleSubmit}>
                  <div className="input">
                    <div className="h">
                      <Input
                        type="text"
                        placeholder="E-mail"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        hasError={error}
                      />
                      <Button type="submit">Join</Button>
                    </div>
                    {error && (
                      <p className="error">Please enter a valid email</p>
                    )}
                    {success && (
                      <p className="success">Thank you for subscribing!</p>
                    )}
                  </div>
                </form>
              </div>
            </Join>
            <p id="some-partners">Some partners who have trusted us:</p>
            <div className="partners">
              <img src={cargowell} alt="Cargowell" />
              <img src={transway} alt="Transway" />
              <img src={seifert} alt="Seifert" />
              <img src={polarlog} alt="Polarlog" />
              <img src={bluewater} alt="Bluewater" />
              <img src={quehenberger} alt="Quehenberger" />
            </div>
          </Section2>
        </EllipseContainer>
      </Container>
    </Static>
  );
};

const listItemIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="48"
    height="48"
    viewBox="0 0 48 48"
    fill="none"
  >
    <path
      d="M18 22L24 28L44 8M32 6H15.6C12.2397 6 10.5595 6 9.27606 6.65396C8.14708 7.2292 7.2292 8.14708 6.65396 9.27606C6 10.5595 6 12.2397 6 15.6V32.4C6 35.7603 6 37.4405 6.65396 38.7239C7.2292 39.8529 8.14708 40.7708 9.27606 41.346C10.5595 42 12.2397 42 15.6 42H32.4C35.7603 42 37.4405 42 38.7239 41.346C39.8529 40.7708 40.7708 39.8529 41.346 38.7239C42 37.4405 42 35.7603 42 32.4V24"
      stroke="url(#paint0_linear_1529_1190)"
      stroke-width="4"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <defs>
      <linearGradient
        id="paint0_linear_1529_1190"
        x1="25"
        y1="6"
        x2="25"
        y2="42"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#DD5626" />
        <stop offset="1" stop-color="#EF4136" />
      </linearGradient>
    </defs>
  </svg>
);

export default HaulierPromo;
